/* @flow */
import Relationship from 'entities/Relationship';
import ToastActions from 'actions/ToastActions';
import { ActionTypes } from 'constants/RelationshipConstants';
import { dispatcher } from 'lib/Dispatcher';

const RelationshipActions = {
  loadRelationship(userId: Backbone$Id | number): Promise<Relationship> {
    return Relationship.fetch({ id: userId }).then(relationship => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_RELATIONSHIP,
        relationship,
      });
      return ((relationship: any): Relationship);
    });
  },

  // Use updateRelationship instead of loadRelationship in cases where it is possible to no longer
  // have a relationship with the user (i.e. unsubscribing & removing user from a class)
  updateRelationship(userId: Backbone$Id): Promise<Relationship | void> {
    return this.loadRelationship(userId).catch(() => {
      dispatcher.dispatch({
        type: ActionTypes.DELETE,
        userId,
      });
    });
  },

  updateName(relatedUserId: Backbone$Id, firstName: string, lastName: string) {
    return Relationship.updateName(relatedUserId, firstName, lastName).then(relationship => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_RELATIONSHIP,
        relationship,
      });
      return relationship;
    });
  },

  updateNote(relatedUserId: number, note: string) {
    return Relationship.updateNote(relatedUserId, note).then(relationship => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_RELATIONSHIP,
        relationship,
      });
      return relationship;
    });
  },

  confirmUntrustedName(relatedUserId: Backbone$Id) {
    return Relationship.confirmUntrustedName(relatedUserId).then(relationship => {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_RELATIONSHIP,
        relationship,
      });
      return relationship;
    });
  },

  block(relatedUserId: number, relatedUserName: string) {
    const successMessage = `${relatedUserName} was successfully blocked.`;
    const errorMessage = `Unable to block ${relatedUserName}.`;
    Relationship.block(relatedUserId)
      .then(relationship => {
        dispatcher.dispatch({
          type: ActionTypes.UPDATE_RELATIONSHIP,
          relationship,
        });
        return relationship;
      })
      .then(() => ToastActions.showSuccessToast(successMessage))
      .catch(() => ToastActions.showErrorToast(errorMessage));
  },

  unblock(relatedUserId: Backbone$Id, relatedUserName: string) {
    const successMessage = `${relatedUserName} was successfully unblocked.`;
    const errorMessage = `Unable to unblock ${relatedUserName}.`;
    Relationship.unblock(relatedUserId)
      .then(relationship => {
        dispatcher.dispatch({
          type: ActionTypes.UPDATE_RELATIONSHIP,
          relationship,
        });
        return relationship;
      })
      .then(() => ToastActions.showSuccessToast(successMessage))
      .catch(() => ToastActions.showErrorToast(errorMessage));
  },
};

export default RelationshipActions;
